import "./Home.css";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Img_URL1 } from "./Ads_URL";

const HomeHCB = () => {
  const [yachts, setYachts] = useState([]);
  const make = "HCB";
  const condition = "New,Used";

  const fetchData = () => {
    let apiUrl = `https://americanyachtgroupinternational.com/api/documents?brand=${make}&condition=${condition}&priority_brokerage=40000836`;
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);
        const yachtsArray = data?.yacht_data?.["V-Data"] || [];
        const limitedYachts = yachtsArray.slice(0, 8);
        setYachts(limitedYachts);
      })
      .catch((error) => console.error("Error fetching yachts:", error));
  };

  useEffect(() => {
    fetchData();
  }, [make]);
  useEffect(() => {
    const video1 = document.getElementById("video1");
    const video2 = document.getElementById("video2");

    let isVideo1Active = true;
    const interval = setInterval(() => {
      if (video1 && video2) {
        if (isVideo1Active) {
          video1.style.opacity = "0";
          video2.style.opacity = "1";
        } else {
          video1.style.opacity = "1";
          video2.style.opacity = "0";
        }
        isVideo1Active = !isVideo1Active;
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className="mob-banner d-md-none mb-4">
        <iframe
          src="https://player.vimeo.com/video/968137876?background=1"
          style={{
            position: "absolute",
            top: " 50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "177.77777778vh",
            height: "56.25vw",
            boxSizing: "border-box",
            minHeight: "100%",
            minWidth: "100%",
          }}
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen=""
          data-ready="true"
          title="hcb-video"
        ></iframe>
        <div className="mob-banner-text container-fluid col-lg-11">
          <div>
            <Row className="g-2 mb-2 d-flex justify-content-center">
              <Col
                xs={6}
                md={4}
                lg={2}
                className="btn btn-light "
                type="button"
              >
                <Link
                  to={`/hcb`}
                  className="text-dark fs-5"
                  onClick={handleClick}
                >
                  Explore Models
                </Link>
              </Col>

              <Col xs={6} md={4} lg={2} className="btn btn-dark" type="button">
                <Link
                  to={`/yachts-for-sale?make=HCB`}
                  className="text-white fs-5"
                  onClick={handleClick}
                >
                  View Inventory
                </Link>
              </Col>
            </Row>
          </div>
          <p className="mb-0 fs-5 fw-bold">
            Performance. Luxury. Comfort. Athleticism.
          </p>
        </div>
      </div>

      <div className="banner d-none d-md-block">
        <div className="banner-content">
          <iframe
            src="https://player.vimeo.com/video/968137876?background=1"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="hcb-video"
          ></iframe>
          <div className="banner-text">
            <h5 className="text-center fw-bold text-white">
              Performance. Luxury. Comfort. Athleticism.
            </h5>
            <div className="text-center row">
              <div className="col-6 text-end">
                <Link
                  to={`/hcb`}
                  className="btn btn-light me-2"
                  onClick={handleClick}
                >
                  Explore Models
                </Link>
              </div>
              <div className="col-6 text-start">
                <Link
                  to={`/yachts-for-sale?make=HCB`}
                  className="btn btn-dark"
                  onClick={handleClick}
                >
                  View Inventory
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Yacht Listings */}
      <div>
        <Container fluid className="col-lg-11 pt-4">
          <h5 className="text-dark fw-bold mb-4">
            Explore Featured HCB Collection
          </h5>
          <Row className="g-3">
            {yachts.length === 0 ? (
              <div className="text-center">
                <Spinner animation="border" variant="warning" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              yachts.map((yacht, index) => (
                <React.Fragment key={yacht.ID}>
                  <Col xs={12} md={6} lg={4}>
                    <Link to={`/yachtdetails/${yacht.ID}`} className="">
                      <div
                        className="card border-0"
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                        }}
                      >
                        <img
                          src={
                            yacht.DisplayPicture?.Large ||
                            yacht.DisplayPicture?.Medium
                          }
                          className="card-img-top"
                          alt="..."
                          loading="lazy"
                          height={"260px"}
                        />
                        <div className="card-body p-2">
                          <div className="text-start">
                            <h5 className="fw-bold mb-1">
                              {yacht.Manufacturer}{" "}
                              <span className="text-dark">{yacht.Model}</span>
                            </h5>
                          </div>
                          <p className="text-dark mb-0">
                            {yacht.Year} | {yacht.City}, {yacht.State},{" "}
                            {yacht.Country}
                          </p>
                          <div className="d-flex justify-content-between">
                            <div>
                              <p className="fw-bold">
                                {yacht.PriceHidden
                                  ? "$ Call For Price"
                                  : yacht.PriceUSD != null
                                  ? new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    }).format(yacht.PriceUSD)
                                  : "$ Not Available"}
                              </p>
                            </div>
                            <div className="text-dark fw-bold">
                              View Details{" "}
                              <i className="fa-solid fa-angles-right"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </Col>

                  {index === 2 && (
                    <Col xs={12} md={6} lg={4} key="advertisement">
                      <div
                        className="border-0 py-4 rounded-2 bg-white"
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                        }}
                      >
                        <div className="d-flex justify-content-center align-items-center">
                          <img
                            src={Img_URL1}
                            alt="Advertisement"
                            height={"305px"}
                            width={"auto"}
                          />
                        </div>
                      </div>
                    </Col>
                  )}
                </React.Fragment>
              ))
            )}
          </Row>
        </Container>
      </div>

      <Container fluid className="col-lg-11">
        <Link to={`/yachts-for-sale?make=HCB`} className=" fs-5">
          <div className="mt-3 p-3 text-center gradient-c1">
            <span style={{ color: "#274c70" }} className="fw-bold">
              View Our Wide Collection Of New and Used HCB Yachts{" "}
              <i className="fa-solid fa-angles-right"></i>
            </span>
          </div>
        </Link>
      </Container>
    </>
  );
};

export default HomeHCB;
